import { Blocs } from '@business/blocs';
import { OrgId } from '@business/entities/organization';
import { BaseBloc } from '@core/utils/bloc';
import { resolve } from '@core/utils/ioc';
import { LoadingState } from '@core/utils/repository/loading_state';
import { BehaviorSubject, combineLatest, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { OrdersFilterData } from './TimeMaterialsList';
import { TimeMaterialStatus } from '@business/entities/tm';
import { TMBoardId } from '@business/entities/tm/TimeMaterialBoardResponse';

export class TimeMaterialsListBloc extends BaseBloc {
  private readonly orderBloc = resolve(Blocs.timeMaterial);
  private readonly stageBloc = resolve(Blocs.tmStage);
  private readonly orgBloc = resolve(Blocs.organization);

  loading = new LoadingState();

  constructor(private readonly orgId: OrgId, private readonly boardId: TMBoardId) {
    super();
  }

  filters$ = new BehaviorSubject<OrdersFilterData>({ status: TimeMaterialStatus.open, stage: '' });
  orders$ = this.orderBloc.orders$;
  stages$ = this.stageBloc.stages$;
  organization$ = this.orgBloc.selectOrganization(this.orgId);

  readonly filteredOrders$ = combineLatest(this.filters$, this.orders$).pipe(
    map(([filters, orders]) => {
      return orders.filter(o => {
        if (o.organization.id != this.orgId) {
          return false;
        }
        if (filters.status && filters.status !== o.status) {
          return false;
        }

        if (filters.stage && filters.stage !== o.stage.id) {
          return false;
        }
        return true;
      });
    }),
  );

  onInit() {
    return forkJoin([
      this.orderBloc.fetchOrgOrders(this.orgId),
      this.stageBloc.fetchStages(this.boardId),
      this.orgBloc.fetchOrganization(this.orgId),
    ]).pipe(this.loading.run());
  }

  updateStatus = this.orderBloc.updateStatus;
  processTmInvoicePayment = this.orderBloc.processTmInvoicePayment;
}
